// extracted by mini-css-extract-plugin
export default {"clickable":"TableItem_clickable__GbgiR","icon":"TableItem_icon__j-d3W"};